import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';

const ContaPagarFilterBar = ({ filters, onFilterChange, onClearFilters }) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const handleClear = () => {
    onClearFilters();
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Descrição */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Descrição
          </label>
          <input
            type="text"
            value={filters.descricao || ''}
            onChange={(e) => handleFilterChange('descricao', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Filtrar por descrição..."
          />
        </div>

        {/* Status de Pagamento */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            value={filters.pago || ''}
            onChange={(e) => handleFilterChange('pago', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">Todos</option>
            <option value="Sim">Pago</option>
            <option value="Não">Pendente</option>
          </select>
        </div>

        {/* Data de Vencimento (Início) */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Vencimento (De)
          </label>
          <input
            type="date"
            value={filters.dataVencimentoInicio || ''}
            onChange={(e) => handleFilterChange('dataVencimentoInicio', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Data de Vencimento (Fim) */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Vencimento (Até)
          </label>
          <input
            type="date"
            value={filters.dataVencimentoFim || ''}
            onChange={(e) => handleFilterChange('dataVencimentoFim', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Valor Mínimo */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Valor Mínimo
          </label>
          <input
            type="number"
            step="0.01"
            value={filters.valorMin || ''}
            onChange={(e) => handleFilterChange('valorMin', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="0,00"
          />
        </div>

        {/* Valor Máximo */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Valor Máximo
          </label>
          <input
            type="number"
            step="0.01"
            value={filters.valorMax || ''}
            onChange={(e) => handleFilterChange('valorMax', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="0,00"
          />
        </div>

        {/* Conta */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Conta
          </label>
          <input
            type="text"
            value={filters.conta || ''}
            onChange={(e) => handleFilterChange('conta', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Filtrar por conta..."
          />
        </div>

        {/* Cadastrado Por */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Cadastrado Por
          </label>
          <input
            type="text"
            value={filters.cadastradoPor || ''}
            onChange={(e) => handleFilterChange('cadastradoPor', e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Filtrar por usuário..."
          />
        </div>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        <button
          onClick={handleClear}
          className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white text-sm font-medium rounded-md transition-colors duration-200 flex items-center space-x-2"
        >
          <FontAwesomeIcon icon={faEraser} />
          <span>Limpar Filtros</span>
        </button>
      </div>
    </div>
  );
};

export default ContaPagarFilterBar;
